import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { ClientDialog } from 'src/modules/supply_chain/components/ClientDialog'
import { skuit } from 'src/services/skuit'

import { ClientListTable } from 'src/components/Table/list/Client'
import { ListPage } from 'src/components/Pages/ListPage'

export const ClientListPage = () => {
  const paginator = useQueryPaginator(
    'client-list',
    skuit.sc.clients.list
  )

  const exportFields = [
    'allow_co_mingling',
    'created_on',
    'guid',
    'is_active',
    'name',
  ]

  return (
    <ListPage
      title='Clients'
      paginator={paginator}
      dialogs={[{ title: 'New Client', Dialog: ClientDialog }]}
    >
      <ClientListTable
        paginator={paginator}
        fields={['name', 'isActive']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.clients.export
        }}
      />
    </ListPage>
  )
}
